import { User } from "lucide-react";
import { Navigate, useSearchParams } from "react-router-dom";

import { useGetAuthUser } from "@/api/get-user";
import { LoadingScreen } from "@/components/loading-screen";
import { useGetInvitation } from "@/features/registration/api/get-invitation";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { SwitchAccountToAcceptInvitation } from "@/features/registration/components/switch-account-to-accept-invitation";
import { YourDetailsForm } from "@/features/registration/components/your-details.form";

export function YourDetails() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const { data: user } = useGetAuthUser();

  const {
    data: invitation,
    isLoading,
    isError,
  } = useGetInvitation(
    { id: code ?? "" },
    {
      enabled: !!code,
    },
  );

  if (user) {
    return <SwitchAccountToAcceptInvitation />;
  }

  if (isLoading) {
    return (
      <>
        <OnboardingHeader
          title="Your Details"
          description="Please confirm your account details"
          Icon={User}
          className="mb-6"
        />
        <LoadingScreen />
      </>
    );
  }

  if (isError) {
    return <Navigate to={`/sign-up/welcome?code=${code}`} replace />;
  }

  return (
    <>
      <OnboardingHeader
        title="Your Details"
        description="Please confirm your account details"
        Icon={User}
        className="mb-6"
      />
      <YourDetailsForm invitation={invitation} />
    </>
  );
}
